import { render, staticRenderFns } from "./TasksToObservePage.vue?vue&type=template&id=68b29f18"
import script from "./TasksToObservePage.vue?vue&type=script&lang=js"
export * from "./TasksToObservePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports